import { logError } from "common/error";
import { cut } from "from-start/crossCutter";
import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
import { nothing } from "lit-html";
import { classMap } from "lit-html/directives/class-map";
import { styleMap } from "lit-html/directives/style-map";
import log from "loglevel";
export const videoEndEvent = "videoEnd";
export const clickTicketEvent = "clickTicket";
export const nextButtonAppearEvent = "nextButtonAppear";
export const moveNextClickEvent = "moveNextClick";
export class Announce extends LitElement {
    constructor() {
        super(...arguments);
        this.showTicket = false;
        this.showVideo = false;
        this.fadeIn = true;
        this.fadeOut = false;
        this.nextButtonAppear = false;
    }
    static get properties() {
        return {
            showTicket: { type: Boolean },
            showVideo: { type: Boolean },
            fadeOut: { type: Boolean },
        };
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        // 다음 프레임에 fadein을 시작한다. 쳣 프레임에 시작하면 CSS 애니메이션이 동작하지 않는다.
        setTimeout(() => {
            log.trace("disable fadein", this);
            this.fadeIn = false;
            this.requestUpdate();
        }, 0);
    }
    render() {
        const style = {
            transition: "1s filter linear",
        };
        const klass = {
            "fade-out": this.fadeOut,
            "fade-in": this.fadeIn,
        };
        return html `<div class="${classMap(klass)}" style="${styleMap(style)}">
      <img src="${paths.announceBackgroundGif}" class="absolute" />
      ${this.renderTicket()} ${this.renderVideo()} ${this.renderReady()}
    </div>`;
    }
    renderTicket() {
        if (this.showTicket) {
            const style = {};
            return html `<img
        src="${paths.announceTicketGif}"
        class="pointer-allow absolute"
        @click=${this.onTicketClick}
        style=${styleMap(style)}
      />`;
        }
        else {
            return nothing;
        }
    }
    renderVideo() {
        const klass = {
            dn: !this.showVideo,
            absolute: true,
            "pointer-allow": true,
        };
        return html `<video
      src="${paths.announceVideo}"
      playsinline
      webkit-playsinline
      class="${classMap(klass)}"
      @ended=${this.handleVideoEnd}
      @timeupdate=${this.handleVideoTimeUpdate}
      @click=${this.handleVideoClick}
    />`;
    }
    renderReady() {
        const klass = {
            dn: !this.nextButtonAppear,
            absolute: true,
        };
        return html `<img src=${paths.announceYes} class="${classMap(klass)}" />`;
    }
    onTicketClick(ev) {
        log.debug("announce ticket click handler");
        ev.stopPropagation();
        const videoElement = this.querySelector("video");
        this.querySelector("video")
            .play()
            .catch(logError)
            .then(() => {
            cut({
                name: "announceVideoPlay",
                videoElement,
            });
        });
        this.dispatchEvent(new CustomEvent(clickTicketEvent));
    }
    handleVideoEnd(ev) {
        log.debug("announce video end");
        ev.stopPropagation();
        this.dispatchEvent(new CustomEvent(videoEndEvent));
    }
    handleVideoTimeUpdate(ev) {
        ev.stopPropagation();
        const videoElement = this.querySelector("video");
        if (videoElement.currentTime >= 58) {
            if (this.nextButtonAppear === false) {
                log.debug("announce video show next button", ev);
                this.nextButtonAppear = true;
                this.requestUpdate();
                cut({ name: "announceShowNextButton", videoElement });
                this.dispatchEvent(new CustomEvent(nextButtonAppearEvent));
            }
        }
        else {
            if (this.nextButtonAppear === true) {
                log.warn("announce video resetted", ev);
                this.nextButtonAppear = false;
            }
        }
        if (videoElement.currentTime >= 62) {
            videoElement.currentTime = 59;
        }
    }
    handleVideoClick(ev) {
        log.debug("announce this.handleVideoClick", ev);
        ev.stopPropagation();
        if (this.nextButtonAppear) {
            log.debug("announce dispatch moveNextClickEvent");
            this.dispatchEvent(new CustomEvent(moveNextClickEvent));
        }
        else {
            log.trace("announce do not dispatch moveNextClickEvent");
        }
    }
}
customElements.define("jh-announce", Announce);
//# sourceMappingURL=announce.js.map